import guest from './guest'
import auth from './auth'

/**
 * Cleaning up the middleware 
 * 
 * @param {any} context 
 * This is the context object we created earlier on so that it can be passed to each piece of middleware in the stack.
 * @param {any} middleware 
 * This is the middleware array itself as defined on the meta field of the route.
 * @param {any} index 
 * This is the index of the current middleware being run in the middleware array.
 * 
 * @returns {function}
 */
const middlewarePipeline = function (context, middleware, index) {

    const nextMiddleware = middleware[index]

    if(!nextMiddleware){
        return context.next 
    }

    return () => {
        const nextPipeline = middlewarePipeline(
            context, middleware, index + 1
        )
        nextMiddleware({ ...context, next: nextPipeline })
    }
}


export { guest, auth, middlewarePipeline }